/* DeleteAction.js */

"use strict";

class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, OsImageEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._osImageEntity = OsImageEntity;
        this._selectedImagesIds = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedImagesIds = this._activeView.getSelectedImageIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        const selectedIdsLength = this._selectedImagesIds.length;
        if (selectedIdsLength) {
            return this._activeView.pagingFeed
                .getFileEntitiesNameByIds(this._selectedImagesIds)
                .then((selectedImagesNames) => {
                    this._message = `Are you sure you want to permanently delete the selected file${
                        selectedIdsLength > 1 ? "s" : ""
                    }?\n
                                ${selectedImagesNames.join("\n")}`;
                    return this._gameEditor
                        .runQuickConfirmationActionWorkflow(
                            {
                                message: this._message,
                                title: "Delete",
                                confirmDetails: {
                                    text: "Confirm",
                                    type: "destructive",
                                },
                                rejectDetails: {
                                    text: "Cancel",
                                    type: "text",
                                },
                            },
                            () => {
                                return this._deleteFiles(this._selectedImagesIds).then(() => {
                                    this._modalUserFeedback.hideDisplayed();
                                    this._activeView.resetSelection();
                                });
                            }
                        )
                        .catch((err) => {
                            this._logger.warn({error: err}, "DeleteAction.run() - Error");
                            return this._modalUserFeedback.displayError(err);
                        });
                });
        } else {
            return Promise.resolve();
        }
    }

    _deleteFiles(ids) {
        let promiseChain = Promise.resolve();
        ids.forEach((itemId) => {
            promiseChain = promiseChain.then(() => {
                return this.deleteItem(itemId);
            });
        });
        return promiseChain;
    }
    /* jshint ignore:start */
    async deleteItem(itemId) {
        let osImage = await this._osImageEntity.loadAscendOsImage(this._activeOrgId, itemId);
        return osImage && osImage.delete();
    }
    /* jshint ignore:end */
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.OsImage",
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete Files",
    order: 6,
};
